import { render } from "./DesignPostQuestionModal.vue?vue&type=template&id=5a9c41d6&scoped=true&ts=true"
import script from "./DesignPostQuestionModal.vue?vue&type=script&lang=ts"
export * from "./DesignPostQuestionModal.vue?vue&type=script&lang=ts"

import "./DesignPostQuestionModal.vue?vue&type=style&index=0&id=5a9c41d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9c41d6"]])

export default __exports__